import { render } from "./OverlayLayout.vue?vue&type=template&id=06f39006&scoped=true"
const script = {}

import "./OverlayLayout.vue?vue&type=style&index=0&id=06f39006&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f39006"]])

export default __exports__